
import platform from '../util/platform';

var result = !platform.is.WEBKIT;

export default function () {
  return result;
}
//# sourceMappingURL=focus-in-zero-dimension-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-in-zero-dimension-object.js
// module id = 187
// module chunks = 0 1